module.exports = __webpack_public_path__ + "static/img/jisoo2.fdc4d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/jisoo2.jpg
// module id = +1tT
// module chunks = 18